module.exports = function (data) {

    switch (data.event) {
        case 'BWSAUupdateStorePreference':
            let dataArea;

            if (data.area === undefined) {
                dataArea = 'Store search';
            } else {
                dataArea = data.area;
            }

            data.eventContext = {
                area: dataArea,
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode,
                selectedStoreOrder: data.store.SelectedStoreOrder
            };
            break;
        case 'BWSAUupdateStorePreferenceShopLocator':
            data.eventContext = {
                area: 'Shop locator',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUupdateStorePreferenceStorePage':
            data.eventContext = {
                area: 'Store Details page',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUupdateStorePreferenceOutOfStock':
            data.eventContext = {
                area: 'Check stock at other stores',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUupdateStorePreferenceHelpDeliveryPage':
            data.eventContext = {
                area: 'Help delivery page',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUupdateStorePreferenceLocationShared':
            data.eventContext = {
                area: 'Location shared',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUupdateStorePreferenceShareLocationBanner':
            data.eventContext = {
                area: 'Location banner',
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                locationBannerInteraction: data.store.LocationBannerInteraction
            };
            break;
        case 'BWSAUupdateStorePreferencePickup':
            data.eventContext = {
                area: 'Pick up page',
                newStoreId: data.store.StoreNo,
                newStoreName: data.store.Name,
                newStoreFullfilmentType: data.fulfilmentInfo.FulfilmentMethod,
                newPostCode: data.store.Postcode
            };
            break;
        case 'BWSAUdeliveryOverlay':
            data.eventContext = {
                area: 'Delivery Overlay',
                deliveryOverlayAddress: data.store.DeliveryOverlayAddress,
                deliveryOverlayInteraction: data.store.DeliveryOverlayInteraction
            };
            break;
        case 'BWSAUselectStoreSuburb':
            data.eventContext = {
                area: 'Select store suburb',
                selectedSuburb: data.store.SelectedSuburb,
                setDeliveryvisible: data.store.SetDeliveryvisible
            };
            break;
    }

    const event = {
        event: data.event,
        eventContext: data.eventContext
    };

    if (data.store.Stockcode) {
        event.eventContext.stockcode = data.store.Stockcode;
        event.eventContext.isBoAvailable = data.store.IsBoAvailable;
        event.eventContext.isFoAvailable = data.store.IsAvailable;
    }

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/atm/set-store-mapper.js
 **/